package io.horion.auth.api.models.response

import kotlinx.serialization.Serializable

@Serializable
data class LoginResponse(
    val token: Token,
    val requiresVerification: Boolean = false,
    val message: String
)

@Serializable
data class Token(
    val accessToken: String,
    val refreshToken: String
)